







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import data from "@/services/data/vita-investimento";
import categories, { query_type_categories, chart_type_categories, sorting_methods_categories, statistics_categories , file_formats } from "@/services/categories";
import PnetTable from '@previnet/vue-table';
import ComboBox from "@/components/ComboBox.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { PnetInput } from "@previnet/vue-input";
import { clone , isNil, merge } from 'ramda';
import { it } from "vuejs-datepicker/dist/locale";
import properties from "@/services/properties/vita-investimento";
import { format } from "date-fns";
import Header from "@/components/Header.vue";
import BarChart from '@/components/charts/BarChart.vue';
import GroupedBarChart from '@/components/charts/GroupedBarChart.vue';
import PieChart from '@/components/charts/PieChart.vue';
import jquery from 'jquery';
import { mapGetters } from 'vuex';
import { Filter } from '@/services/filters';

const FILTER_KEY = "vita-investimento-dashboard";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user','fromDatabase'],
  components: {
    PnetDatePicker,
    PnetInput,
    PnetTable,
    ComboBox,
    Header,
    MultiComboBox,
    BarChart,
    GroupedBarChart,
    PieChart,
  },
  computed: {
    ...mapGetters('filters', {
      filterById: 'byId',
    })
  },
  data: function() {
    return {
      router: this.$router,
      issuesMap: {} as any,
      models: [] as any,
      statisticsMap: {} as any,
      slide: 0,
      sliding: null as any,
      actualSlide: 0,
      isCheckedCompagnia: false,
      isCheckedDistributori: false,
      isCheckedTipologiaProdotto: false,
      isCheckedSostenibilita: false,
      isCheckedRamoISFDR: false,
      isCheckedRamoITassonomiaUE: false,
      isCheckedRamoIPAI: false,
      isCheckedRamoIIIPresenzaFondiInterniArt8SFDR: false,
      isCheckedRamoIIITassonomiaUEFondiInterniArt8: false,
      isCheckedRamoIIIPresenzaFondiInterniArt9SFDR: false,
      isCheckedRamoIIITassonomiaUEFondiInterniArt9: false,
      isCheckedRamoIIIPAIFondiInterni: false,
      isCheckedRamoIIIPresenzaOICRETFArt8SFDR: false,
      isCheckedRamoIIITassonomiaUEOICRETFArt8: false,
      isCheckedRamoIIIPresenzaOICRETFArt9SFDR: false,
      isCheckedRamoIIITassonomiaUEOICRETFArt9: false,
      isCheckedRamoIIIPAIOICRETF: false,
      loggedUser: this.$props.user,
      codCategoriaProdotto: categories.VITA_INVESTIMENTO,
      listaProdottiCensiti: [] as any[],
      showFilter: true,
      filterOptions: {
        compagnia: [],
        mercato: [],
        canale: [],
        distributori: [],
        tipologiaProdotto: [],
        tipologiaSottostanti: [],
        prodottoInCommercio: [],
        tipologiaPremio: [],
      },
      changedFilterFields: [],      
      filtroRicerca: {
        //prodotto: [] as any,
        compagnia: [] as any,
        mercato: [] as any,
        canale: [] as any,
        distributori: [] as any,
        tipologiaProdotto: [] as any,
        tipologiaSottostanti: [] as any,
        prodottoInCommercio: null as any,
        inizioCommercializzazioneDaDate: undefined,
        inizioCommercializzazioneADate: undefined,
        fineCommercializzazioneDaDate: undefined,
        fineCommercializzazioneADate: undefined,
        inizioCommercializzazioneDa: undefined,
        inizioCommercializzazioneA: undefined,
        fineCommercializzazioneDa: undefined,
        fineCommercializzazioneA: undefined,
        tipologiaPremio: [] as any,
        impMinPremioUnicoDa: undefined,
        impMinPremioUnicoA: undefined,
        impMinPremioRicorrenteDa: undefined,
        impMinPremioRicorrenteA: undefined,
      },
      filtroRicercaDB: {
        prodottoCompleto: undefined,
        prodotto: [] as any,
        compagnia: [] as any,
        mercato: [] as any,
        canale: [] as any,
        distributori: [] as any,
        tipologiaProdotto: [] as any,
        tipologiaSottostanti: [] as any,
        prodottoInCommercio: undefined,
        inizioCommercializzazioneDaDate: undefined,
        inizioCommercializzazioneADate: undefined,
        fineCommercializzazioneDaDate: undefined,
        fineCommercializzazioneADate: undefined,
        inizioCommercializzazioneDa: undefined,
        inizioCommercializzazioneA: undefined,
        fineCommercializzazioneDa: undefined,
        fineCommercializzazioneA: undefined,
        tipologiaPremio: [] as any,
        impMinPremioUnicoDa: undefined,
        impMinPremioUnicoA: undefined,
        impMinPremioRicorrenteDa: undefined,
        impMinPremioRicorrenteA: undefined,
        otherField: {
          key: null as any,
          value: null as any
        }
      },
      filtroRicercaAdapted: null,
      nomeFiltroRicercaDaSalvare: undefined,
      savedSearchFiltersList: [] as any,
      actualSavedFilter: null as any,
      operationToConfirm: "",
      msgError: "",
      msgSuccess: "",
      msgConfirmOperation: "",
      it,
      ...data,
      ...properties,
      prodottiOptions: [] as any,
      distributoriOptions: [] as any,
      compagnieOptions: [] as any,
      ND: "n.d.",
      isAllChartsSelected: true,
      isSectionChartsSelected: {
        "CARATTERISTICHE GENERALI":true,
        "REQUISITI DI SOTTOSCRIZIONE":true,
        "KID":true,
        "INVESTIMENTO IN GESTIONE SEPARATA":true,
        "INVESTIMENTO IN RAMO III":true,
        "OPZIONI":true,
        "GARANZIE":true,
        "BONUS":true,
        "COSTI":true,
        "RETROCESSIONE":true,
        "SOSTENIBILITA":true,
      },
      baseYearRendGs: 2020,
      maxViewAnniRendGs: 5,
      anniRendGs: [] as any,
      rendGsColors: ["#d9e6ee", "#a2c2d2", "#679dba", "#467c9c", "#366079"],
      rgbRendGsColors: [] as any,
      chartNamesArray: [],
      mapIndexSlide: {
        0: {
          sectionName:"CARATTERISTICHE GENERALI",name:"Compagnia",fieldName:"compagnia",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.compagniaOptions,sortingMethod:sorting_methods_categories.ISSUES_DESCRIPTION_COMPARE_ASC,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true,
          statistics:true,
          statisticsParams:{fieldName:"compagnia",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.COUNT,xExclude:[],legendMapping:undefined,otherOptions:[],
            statisticsTypes:[statistics_categories.SUM],
            statisticsLabelsMapping:{"sum":"Totale prodotti"}
          },
        },
        1: {sectionName:"CARATTERISTICHE GENERALI",name:"Mercato",fieldName:"mercato",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.mercatoOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        2: {sectionName:"CARATTERISTICHE GENERALI",name:"Canale",fieldName:"canale",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.canaleOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        3: {sectionName:"CARATTERISTICHE GENERALI",name:"Distributori",fieldName:"distributori",chartType:chart_type_categories.BAR_CHART,code:properties.distributoriProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_VALUE_AND_DESCRIPTION_ASC_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        4: {sectionName:"CARATTERISTICHE GENERALI",name:"Tipologia prodotto",fieldName:"tipologia_prodotto",chartType:chart_type_categories.BAR_CHART,code:properties.tipologiaProdottoProperty.code,options:data.tipologiaProdottoOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        5: {sectionName:"CARATTERISTICHE GENERALI",name:"Tipologia sottostanti",fieldName:"tipologia_sottostanti__combination",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaSottostantiOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COMBINATION,fasce:undefined,legendMapping:undefined,isSelected:true},
        6: {sectionName:"CARATTERISTICHE GENERALI",name:"Inizio commercializzazione",fieldName:"inizio_commercializzazione",chartType:chart_type_categories.BAR_CHART,code:properties.inizioCommProperty.code,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_DESCRIPTION_COMPARE_DESC,queryType:query_type_categories.BY_YEAR,fasce:undefined,legendMapping:undefined,isSelected:true},
        7: {sectionName:"REQUISITI DI SOTTOSCRIZIONE",name:"Tipologia premio",fieldName:"tipologia_premio",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaPremioOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        8: {sectionName:"REQUISITI DI SOTTOSCRIZIONE",name:"Importo minimo premio unico",fieldName:"importo_minimo_premio_unico",chartType:chart_type_categories.BAR_CHART,code:properties.importoMinPremioUnicoProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FASCE,
          fasce:[ 
            ["< € 25.000","0","24999"],
            ["€ 25.000 - € 49.999","25000","49999"],
            ["€ 50.000 - € 74.999","50000","74999"],
            ["€ 75.000 - € 99.999","75000","99999"],
            ["€ 100.000 - € 249.999","100000","249999"],
            ["€ 250.000 - € 499.999","250000","499999"],
            ["€ 500.000 - € 999.999","500000","999999"],
            [">= € 1.000.000","1000000","1000000000"],
            ["Non indicato",undefined],
          ],
          legendMapping:undefined,isSelected:true},
        9: {sectionName:"REQUISITI DI SOTTOSCRIZIONE",name:"Importo minimo premio ricorrente (annuo)",fieldName:"importo_minimo_premio_ricorrente",chartType:chart_type_categories.BAR_CHART,code:properties.importoMinPremioRicAnnuoProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FASCE,
          fasce:[ 
            ["< € 1.000","0","999"],
            ["€ 1.000 - € 2.499","1000","2499"],
            ["€ 2.500 - € 4.999","2500","4999"],
            ["€ 5.000 - € 9.999","5000","9999"],
            [">= € 10.000","10000","1000000000"],
            ["Non indicato",undefined],
          ],
          legendMapping:undefined,
          isSelected:true
        },
        10: {sectionName:"KID",name:"Orizzonte temporale suggerito (anni)",fieldName:"orizzonte_temporale_suggerito",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.orizzonteTemporaleSuggeritoProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            orizzonte_temporale_suggerito:"Min.   Media   Max.",
          },
          isSelected:true
        },
        11: {sectionName:"KID",name:"Indicatore sintetico di rischio",fieldName:"indicatore_sintetico_rischio",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.indicatoreSinteticoRischioProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            indicatore_sintetico_rischio:"Min.   Media   Max.",
          },
          isSelected:true
        },
        12: {sectionName:"KID",name:"Reduction in Yield - costi di ingresso",fieldName:"reduction_in_yield_costi_di_ingresso",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.reductionInYieldCostiIngressoProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            reduction_in_yield_costi_di_ingresso:"Min.   Media   Max.",
          },
          isSelected:true
        },
        13: {sectionName:"KID",name:"Reduction in Yield - costi di uscita",fieldName:"reduction_in_yield_costi_di_uscita",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.reductionInYieldCostiUscitaProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            reduction_in_yield_costi_di_uscita:"Min.   Media   Max.",
          },
          isSelected:true
        },
        14: {sectionName:"KID",name:"Reduction in yield - costi correnti",fieldName:"reduction_in_yield_costi_correnti",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.reductionInYieldCostiCorrentiProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            reduction_in_yield_costi_correnti:"Min.   Media   Max.",
          },
          isSelected:true
        },
        15: {sectionName:"INVESTIMENTO IN GESTIONE SEPARATA",name:"Investimento minimo in Gestione Separata (polizze Ramo I + Ramo III)",fieldName:"investimento_minimo_in_gs",chartType:chart_type_categories.BAR_CHART,code:properties.invMinGestioneSeparataProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.FASCE_FILTERED_BY_SOTTOSTANTI,
          fasce:[ 
            ["0% - 10%","0","10"],
            ["11% - 20%","11","20"],
            ["21% - 30%","21","30"],
            ["31% - 40%","31","40"],
            ["41% - 50%","41","50"],
            ["51% - 60%","51","60"],
            ["61% - 70%","61","70"],
            ["71% - 80%","71","80"],
            ["81% - 90%","81","90"],
            ["91% - 100%","91","100"],
            ["Non indicato",undefined],
          ],
          otherOptions:["hide_Non_indicato_equals_zero"],
          legendMapping:undefined,
          statistics:true,
          statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX],
          statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max."},
          isSelected:true
        },
        16: {sectionName:"INVESTIMENTO IN GESTIONE SEPARATA",name:"Investimento massimo in Gestione Separata (polizze Ramo I + Ramo III)",fieldName:"investimento_massimo_in_gs",chartType:chart_type_categories.BAR_CHART,code:properties.invMaxGestioneSeparataProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.FASCE_FILTERED_BY_SOTTOSTANTI,
          fasce:[ 
            ["0% - 10%","0","10"],
            ["11% - 20%","11","20"],
            ["21% - 30%","21","30"],
            ["31% - 40%","31","40"],
            ["41% - 50%","41","50"],
            ["51% - 60%","51","60"],
            ["61% - 70%","61","70"],
            ["71% - 80%","71","80"],
            ["81% - 90%","81","90"],
            ["91% - 100%","91","100"],
            ["Non indicato",undefined],
          ],
          otherOptions:["hide_Non_indicato_equals_zero"],
          legendMapping:undefined,
          statistics:true,
          statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX],
          statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max."},
          isSelected:true
        },
        17: {
          sectionName:"INVESTIMENTO IN GESTIONE SEPARATA",
          name:"Rendimento Gestione Separata",
          fieldName:"",
          chartType:chart_type_categories.GROUPED_BAR_CHART,
          code:undefined,
          options:undefined,
          sortingMethod:undefined,
          queryType:query_type_categories.STANDARD_FOR_MIN_MAX,
          fasce:undefined,
          legendMapping:undefined,
          isSelected:true,
          fieldNameMapping:{
            min:"Min.",
            avg:"Media",
            max:"Max."
          }
        },
        18: {sectionName:"INVESTIMENTO IN GESTIONE SEPARATA",name:"Rendimento minimo garantito",fieldName:"rendimento_minimo_garantito",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.rendMinGarantitoOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        19: {sectionName:"INVESTIMENTO IN GESTIONE SEPARATA",name:"Consolidamento annuo rivalutazioni contrattuali",fieldName:"consolidamento_annuo_rivalutazioni",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.presenzaConsolidamentoAnnuoRivalutazioniContrattualiOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:{Sì:"Riconosciuto",No:"Non riconosciuto"},
          statistics:false,
          statisticsTypes:[statistics_categories.PRODUCTS_COUNT],
          statisticsLabelsMapping:{"products-count":"Totale prodotti"},
          isSelected:true
        },
        20: {sectionName:"INVESTIMENTO IN GESTIONE SEPARATA",name:"Fondo Utili",fieldName:"fondo_utili",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.fondoUtiliOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,
          statistics:false,
          statisticsTypes:[statistics_categories.PRODUCTS_COUNT],
          statisticsLabelsMapping:{"products-count":"Totale prodotti"},
          isSelected:true
        },
        21: {sectionName:"INVESTIMENTO IN RAMO III",name:"Investimento minimo in Ramo III (polizze Ramo I + Ramo III)",fieldName:"investimento_minimo_ramo_iii",chartType:chart_type_categories.BAR_CHART,code:properties.invMinRamoIIIProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.FASCE_FILTERED_BY_SOTTOSTANTI,
          fasce:[ 
            ["0% - 10%","0","10"],
            ["11% - 20%","11","20"],
            ["21% - 30%","21","30"],
            ["31% - 40%","31","40"],
            ["41% - 50%","41","50"],
            ["51% - 60%","51","60"],
            ["61% - 70%","61","70"],
            ["71% - 80%","71","80"],
            ["81% - 90%","81","90"],
            ["91% - 100%","91","100"],
            ["Non indicato",undefined],
          ],
          otherOptions:["hide_Non_indicato_equals_zero"],
          legendMapping:undefined,
          statistics:true,
          statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX],
          statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max."},
          isSelected:true
        },
        22: {sectionName:"INVESTIMENTO IN RAMO III",name:"Investimento massimo in Ramo III (polizze Ramo I + Ramo III)",fieldName:"investimento_massimo_ramo_iii",chartType:chart_type_categories.BAR_CHART,code:properties.invMaxRamoIIIProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.FASCE_FILTERED_BY_SOTTOSTANTI,
          fasce:[
            ["0% - 10%","0","10"],
            ["11% - 20%","11","20"],
            ["21% - 30%","21","30"],
            ["31% - 40%","31","40"],
            ["41% - 50%","41","50"],
            ["51% - 60%","51","60"],
            ["61% - 70%","61","70"],
            ["71% - 80%","71","80"],
            ["81% - 90%","81","90"],
            ["91% - 100%","91","100"],
            ["Non indicato",undefined],
          ],
          otherOptions:["hide_Non_indicato_equals_zero"],
          legendMapping:undefined,
          statistics:true,
          statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX],
          statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max."},
          isSelected:true
        },
        23: {sectionName:"INVESTIMENTO IN RAMO III",name:"Tipologia Fondi Interni",fieldName:"tipologia_fondi_interni",chartType:chart_type_categories.BAR_CHART,code:properties.tipologiaFondiInterniProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FASCE,
          fasce:[ 
            ["Fondi Interni Azionari","Fondi Interni Azionari"],
            ["Fondi Interni Obbligazionari","Fondi Interni Obbligazionari"],
            ["Fondi Interni Bilanciati","Fondi Interni Bilanciati"],
            ["Fondi Interni Flessibili","Fondi Interni Flessibili"],
            ["Fondi Interni Monetari","Fondi Interni Monetari"],
          ],
          legendMapping:undefined,
          isSelected:true
        },
        /*24: {name:"tipologia_fondi_interni__combination_count",fieldName:"tipologia_fondi_interni__combination_count",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaFondiInterniOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COMBINATION_COUNT,
          fasce:[
            ["1 tipologia","1"],
            ["2 tipologie","2"],
            ["3 tipologie","3"],
            ["4 tipologie","4"],
            ["5 tipologie","5"],
          ],
          legendMapping:undefined
        },*/
        24: {sectionName:"INVESTIMENTO IN RAMO III",name:"Numerosità Fondi Interni",fieldName:"numero_fondi_interni",chartType:chart_type_categories.BAR_CHART,code:properties.numFondiInterniProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FASCE,
          fasce:[ 
            ["1","1","1"],
            ["2-3","2","3"],
            ["4-5","4","5"],
            ["6-10","6","10"],
            ["11-20","11","20"],
            [">20","21","1000000"],
          ],
          legendMapping:undefined,
          isSelected:true
        },
        25: {sectionName:"INVESTIMENTO IN RAMO III",name:"Numerosità OICR/ETF",fieldName:"numero_oicr_etf",chartType:chart_type_categories.BAR_CHART,code:properties.numOICRETFProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FASCE,
          fasce:[ 
            ["1-50","1-50"],
            ["51-100","51-100"],
            ["101-250","101-250"],
            ["251-500","251-500"],
            ["501-1000","501-1000"],
            [">1000",">1000"],
          ],
          legendMapping:undefined,
          isSelected:true
        },
        26: {sectionName:"OPZIONI",name:"Tipologia opzioni",fieldName:"opzioni_contrattuali_tipologia",chartType:chart_type_categories.BAR_CHART,code:properties.opzioniContrattualiTipologiaProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FASCE,
          fasce:[ 
            ["Cedola","Cedola"],
            ["Decumulo","Decumulo"],
            ["Rendita","Rendita"],
            ["Stop Loss","Stop Loss"],
            ["Take Profit","Take Profit"],
            ["Progressive Investment","Progressive Investment"],
            ["Automatic Rebalance","Automatic Rebalance"],
            ["Downtrend Opportunity","Downtrend Opportunity"],            
            ["Life Cycle","Life Cycle"],
            ["Altre opzioni contrattuali","Altre opzioni contrattuali"],
          ],
          legendMapping:undefined,
          isSelected:true
        },
        27: {sectionName:"OPZIONI",name:"Numerosità opzioni",fieldName:"opzioni_contrattuali_tipologia__combination_count",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.opzioniContrattualiTipologiaOptions,sortingMethod:undefined,queryType:query_type_categories.COMBINATION_COUNT,
          fasce:[ 
            ["1","1"],
            ["2","2"],
            ["3","3"],
            ["4","4"],
            ["5","5"],
            ["6","6"],
            ["7","7"],
            ["8","8"],
            ["9","9"],
            ["Nessuna opzione","Non presenti"],
          ],
          legendMapping:undefined,
          statistics:true,
          statisticsParams:{fieldName:"opzioni_contrattuali_tipologia",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.opzioniContrattualiTipologiaOptions,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non presenti'],legendMapping:undefined,
            statisticsTypes:[statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{"products-count-on-tot":"Prodotti con opzioni"}
          },
          isSelected:true
        },
        28: {sectionName:"GARANZIE",name:"Tipologia garanzie",fieldName:"garanzie_assicurative_tipologia",chartType:chart_type_categories.BAR_CHART,code:properties.garanzieAssicurativeTipologiaProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FASCE,
          fasce:[ 
            ["Maggiorazione caso morte standard","Maggiorazione caso morte standard"],
            ["Maggiorazione caso morte per infortunio","Maggiorazione caso morte per infortunio"],
            ["Maggiorazione caso morte per incidente stradale","Maggiorazione caso morte per incidente stradale"],
            ["Maggiorazione caso morte per minusvalenza","Maggiorazione caso morte per minusvalenza"],
            ["TCM stand alone","TCM stand alone"],
            ["Long Term Care","Long Term Care"],
            ["Dread Disease","Dread Disease"],
            ["Invalidità/Inabilità","Invalidità/Inabilità"],
            ["Altre garanzie assicurative","Altre garanzie assicurative"],
          ],
          legendMapping:undefined,
          isSelected:true
        },
        29: {sectionName:"GARANZIE",name:"Numerosità garanzie",fieldName:"garanzie_assicurative_tipologia__combination_count",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.garanzieAssicurativeTipologiaOptions,sortingMethod:undefined,queryType:query_type_categories.COMBINATION_COUNT,
          fasce:[ 
            ["1","1"],
            ["2","2"],
            ["3","3"],
            ["4","4"],
            ["5","5"],
            ["6","6"],
            ["7","7"],
            ["8","8"],
            ["Nessuna garanzia","Non presenti"],
          ],
          legendMapping:undefined,
          statistics:true,
          statisticsParams:{fieldName:"garanzie_assicurative_tipologia",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.garanzieAssicurativeTipologiaOptions,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non presenti'],legendMapping:undefined,
            statisticsTypes:[statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{"products-count-on-tot":"Prodotti con garanzie"}
          },
          isSelected:true
        },
        30: {sectionName:"BONUS",name:"Bonus d'ingresso",fieldName:"tipologia_bonus_ingresso",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaBonusIngressoOptions,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,xExclude:['Non riconosciuto'],legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altro"],
          statistics:true,
          statisticsParams:{fieldName:"bonus_ingresso",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non riconosciuto'],legendMapping:undefined,otherOptions:["avg_of_avg"],
            statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX,statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max.","products-count-on-tot":"Prodotti che riconoscono il bonus"}
          },
          isSelected:true
        },
        31: {sectionName:"BONUS",name:"Bonus fedeltà",fieldName:"tipologia_bonus_fedelta",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaBonusFedeltaOptions,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,xExclude:['Non riconosciuto'],legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altro"],
          statistics:true,
          statisticsParams:{fieldName:"bonus_fedelta",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non riconosciuto'],legendMapping:undefined,
            statisticsTypes:[statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{"products-count-on-tot":"Prodotti che riconoscono il bonus"}
          },
          isSelected:true
        },
        32: {sectionName:"COSTI",name:"Spese di emissione",fieldName:"spese_di_emissione",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.speseEmissioneProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non applicate'],fasce:undefined,legendMapping:undefined,
          statistics:true,
          statisticsTypes:[statistics_categories.PRODUCTS_COUNT_ON_TOT],
          statisticsLabelsMapping:{"products-count-on-tot":"Prodotti che applicano spese di emissione"},
          fieldNameMapping:{
            spese_di_emissione:"Min.   Media   Max.",
          },
          isSelected:true
        },
        33: {sectionName:"COSTI",name:"Caricamento PIC (%)",fieldName:"tipologia_caricamento_pic",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaCaricamentoPICOptions,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,xExclude:['Non applicato'],fasce:undefined,legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altro"],
          statistics:true,
          statisticsParams:{fieldName:"caricamento_pic",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non applicato','n.d.'],legendMapping:undefined,otherOptions:["avg_of_avg","no_zero_in_statistics"],
            statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX,statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max.","products-count-on-tot":"Prodotti che applicano caricamenti %"}
          },
          isSelected:true
        },
        34: {sectionName:"COSTI",name:"Caricamento PAC (%)",fieldName:"tipologia_caricamento_pac",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaCaricamentoPACOptions,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,xExclude:['Non applicato'],fasce:undefined,legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altro"],
          statistics:true,
          statisticsParams:{fieldName:"caricamento_pac",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non applicato','n.d.'],legendMapping:undefined,otherOptions:["avg_of_avg","no_zero_in_statistics"],
            statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX,statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max.","products-count-on-tot":"Prodotti che applicano caricamenti %"}
          },
          isSelected:true
        },
        35: {sectionName:"COSTI",name:"Commissione Gestione Separata",fieldName:"tipologia_commissione_gs",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaCommissioneGestioneSeparataOptions,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altro"],
          statistics:true,
          statisticsParams:{fieldName:"commissione_gestione_separata",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['n.d.'],legendMapping:undefined,otherOptions:["avg_of_avg"],
            statisticsTypes:[statistics_categories.MIN,statistics_categories.AVG,statistics_categories.MAX,statistics_categories.PRODUCTS_COUNT],
            statisticsLabelsMapping:{min:"Min.",avg:"Media",max:"Max.","products-count":"Prodotti che applicano commissioni"}
          },
          isSelected:true
        },
        36: {sectionName:"COSTI",name:"Tipologia commissione Fondi Interni",fieldName:"tipologia_commissione_fondi_interni",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaCommissioneFondiInterniOptions,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altro"],
          statistics:true,
          statisticsParams:{fieldName:"tipologia_commissione_fondi_interni",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaCommissioneFondiInterniOptions,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:undefined,legendMapping:undefined,
            statisticsTypes:[statistics_categories.PRODUCTS_COUNT],
            statisticsLabelsMapping:{"products-count":"Prodotti che applicano commissioni"}
          },
          isSelected:true
        },
        37: {sectionName:"COSTI",name:"Commissione Fondi Interni",fieldName:"commissione_fondi_interni_azionari,commissione_fondi_interni_obbligazionari,commissione_fondi_interni_bilanciati,commissione_fondi_interni_flessibili,commissione_fondi_interni_monetari",chartType:chart_type_categories.GROUPED_BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,otherOptions:["avg_of_avg"],
          fieldNameMapping:{
            commissione_fondi_interni_azionari:"Fondi Interni Azionari",
            commissione_fondi_interni_obbligazionari:"Fondi Interni Obbligazionari",
            commissione_fondi_interni_bilanciati:"Fondi Interni Bilanciati",
            commissione_fondi_interni_flessibili:"Fondi Interni Flessibili",
            commissione_fondi_interni_monetari:"Fondi Interni Monetari",
          },
          isSelected:true
        },
        38: {sectionName:"COSTI",name:"Tipologia spese gestione polizza (OICR/ETF)",fieldName:"tipologia_spese_gestione_polizza_oicretf",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaSpeseGestionePolizzaOICRETFOptions,sortingMethod:sorting_methods_categories.ISSUES_VALUE_MIX_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,otherOptions:["LAST_COLUMNS_MIX_COMPARE#Altro"],
          statistics:true,
          statisticsParams:{fieldName:"tipologia_spese_gestione_polizza_oicretf",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.tipologiaSpeseGestionePolizzaOICRETFOptions,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:undefined,legendMapping:undefined,
            statisticsTypes:[statistics_categories.PRODUCTS_COUNT],
            statisticsLabelsMapping:{"products-count":"Prodotti che applicano spese"}
          },
          isSelected:true
        },
        39: {sectionName:"COSTI",name:"Spese gestione polizza (OICR/ETF)",fieldName:"spese_gestione_polizza_oicretf_azionari,spese_gestione_polizza_oicretf_obbligazionari,spese_gestione_polizza_oicretf_bilanciati,spese_gestione_polizza_oicretf_flessibili,spese_gestione_polizza_oicretf_monetari",chartType:chart_type_categories.GROUPED_BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,
          fieldNameMapping:{
            spese_gestione_polizza_oicretf_azionari:"Spese Gestione Polizza OICR/ETF Azionari",
            spese_gestione_polizza_oicretf_obbligazionari:"Spese Gestione Polizza OICR/ETF Obbligazionari",
            spese_gestione_polizza_oicretf_bilanciati:"Spese Gestione Polizza OICR/ETF Bilanciati",
            spese_gestione_polizza_oicretf_flessibili:"Spese Gestione Polizza OICR/ETF Flessibili",
            spese_gestione_polizza_oicretf_monetari:"Spese Gestione Polizza OICR/ETF Monetari",
          },
          isSelected:true
        },
        40: {sectionName:"COSTI",name:"Commissioni di uscita (%) - applicazione",fieldName:"anno_commissioni_di_uscita",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:sorting_methods_categories.ISSUES_DESCRIPTION_COMM_USCITA,queryType:query_type_categories.COUNT,xExclude:['Non applicate','n.d.'],fasce:undefined,legendMapping:undefined,
          statistics:true,
          statisticsParams:{fieldName:"applicazione_commissioni_di_uscita",chartType:chart_type_categories.BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,xExclude:['Non applicate','n.d.'],legendMapping:undefined,
            statisticsTypes:[statistics_categories.PRODUCTS_COUNT_ON_TOT],
            statisticsLabelsMapping:{"products-count-on-tot":"Prodotti che applicano commissioni di uscita"}
          },
          isSelected:true
        },
        41: {sectionName:"COSTI",name:"Commissioni di uscita (%) - valori",fieldName:"commissioni_di_uscita_anno_1,commissioni_di_uscita_anno_2,commissioni_di_uscita_anno_3,commissioni_di_uscita_anno_4,commissioni_di_uscita_anno_5,commissioni_di_uscita_anno_6,commissioni_di_uscita_anno_7,commissioni_di_uscita_anno_8,commissioni_di_uscita_anno_9,commissioni_di_uscita_anno_10,commissioni_di_uscita_anno_11,commissioni_di_uscita_anno_12,commissioni_di_uscita_anno_13,commissioni_di_uscita_anno_14,commissioni_di_uscita_anno_15,commissioni_di_uscita_anno_16,commissioni_di_uscita_anno_17,commissioni_di_uscita_anno_18,commissioni_di_uscita_anno_19,commissioni_di_uscita_anno_20,commissioni_di_uscita_anno_21,commissioni_di_uscita_anno_22,commissioni_di_uscita_anno_23,commissioni_di_uscita_anno_24,commissioni_di_uscita_anno_25,commissioni_di_uscita_anno_26,commissioni_di_uscita_anno_27,commissioni_di_uscita_anno_28,commissioni_di_uscita_anno_29,commissioni_di_uscita_anno_30",
          chartType:chart_type_categories.GROUPED_BAR_CHART,code:undefined,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,otherOptions:['no_null'],
          fieldNameMapping:{
            commissioni_di_uscita_anno_1:"Nel 1° anno",
            commissioni_di_uscita_anno_2:"Nel 2° anno",
            commissioni_di_uscita_anno_3:"Nel 3° anno",
            commissioni_di_uscita_anno_4:"Nel 4° anno",
            commissioni_di_uscita_anno_5:"Nel 5° anno",
            commissioni_di_uscita_anno_6:"Nel 6° anno",
            commissioni_di_uscita_anno_7:"Nel 7° anno",
            commissioni_di_uscita_anno_8:"Nel 8° anno",
            commissioni_di_uscita_anno_9:"Nel 9° anno",
            commissioni_di_uscita_anno_10:"Nel 10° anno",
            commissioni_di_uscita_anno_11:"Nel 11° anno",
            commissioni_di_uscita_anno_12:"Nel 12° anno",
            commissioni_di_uscita_anno_13:"Nel 13° anno",
            commissioni_di_uscita_anno_14:"Nel 14° anno",
            commissioni_di_uscita_anno_15:"Nel 15° anno",
            commissioni_di_uscita_anno_16:"Nel 16° anno",
            commissioni_di_uscita_anno_17:"Nel 17° anno",
            commissioni_di_uscita_anno_18:"Nel 18° anno",
            commissioni_di_uscita_anno_19:"Nel 19° anno",
            commissioni_di_uscita_anno_20:"Nel 20° anno",
            commissioni_di_uscita_anno_21:"Nel 21° anno",
            commissioni_di_uscita_anno_22:"Nel 22° anno",
            commissioni_di_uscita_anno_23:"Nel 23° anno",
            commissioni_di_uscita_anno_24:"Nel 24° anno",
            commissioni_di_uscita_anno_25:"Nel 25° anno",
            commissioni_di_uscita_anno_26:"Nel 26° anno",
            commissioni_di_uscita_anno_27:"Nel 27° anno",
            commissioni_di_uscita_anno_28:"Nel 28° anno",
            commissioni_di_uscita_anno_29:"Nel 29° anno",
            commissioni_di_uscita_anno_30:"Nel 30° anno",
          },
          isSelected:true
        },
        42: {sectionName:"RETROCESSIONE",name:"Retrocessione - Caricamento (%)",fieldName:"retrocessione_caricamento",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.retrocessioneCaricamentoProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            retrocessione_caricamento:"Min.   Media   Max.",
          },
          isSelected:true
        },
        43: {sectionName:"RETROCESSIONE",name:"Retrocessione - Gestione Separata",fieldName:"retrocessione_gestione_separata",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.retrocessioneGestioneSeparataProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            retrocessione_gestione_separata:"Min.   Media   Max.",
          },
          isSelected:true
        },
        44: {sectionName:"RETROCESSIONE",name:"Retrocessione - Ramo III",fieldName:"retrocessione_ramo_iii",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.retrocessioneRamoIIIProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,
          fieldNameMapping:{
            retrocessione_ramo_iii:"Min.   Media   Max.",
          },
          isSelected:true
        },
        45: {sectionName:"SOSTENIBILITA",name:"Polizza sostenibile ai sensi degli Artt. 8-9 SFDR",fieldName:"sostenibilita",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.sostenibilitaOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        46: {sectionName:"SOSTENIBILITA",name:"SFDR Gestione Separata",fieldName:"ramo_i_sfdr",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoISFDROptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        47: {sectionName:"SOSTENIBILITA",name:"Tassonomia UE Gestione Separata",fieldName:"ramo_i_tassonomia_ue",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoITassonomiaUEOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        48: {sectionName:"SOSTENIBILITA",name:"PAI Gestione Separata",fieldName:"ramo_i_pai",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIPAIOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        49: {sectionName:"SOSTENIBILITA",name:"Presenza Fondi Interni Art. 8 SFDR",fieldName:"ramo_iii_presenza_fondi_interni_art8_sfdr",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIIPresenzaFondiInterniArt8SFDROptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        50: {sectionName:"SOSTENIBILITA",name:"N° Fondi Interni Art. 8 SFDR",fieldName:"ramo_iii_num_fondi_interni_art8_sfdr",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIINumFondiInterniArt8SFDRProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_num_fondi_interni_art8_sfdr:"Min.   Media   Max.",},isSelected:true},
        51: {sectionName:"SOSTENIBILITA",name:"Fondi Interni Art. 8 SFDR (%)",fieldName:"ramo_iii_fondi_interni_art8_sfdr_perc",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIIFondiInterniArt8SFDRPercProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_fondi_interni_art8_sfdr_perc:"Min.   Media   Max.",},isSelected:true},
        52: {sectionName:"SOSTENIBILITA",name:"Tassonomia UE Fondi Interni Art. 8",fieldName:"ramo_iii_tassonomia_ue_fondi_interni_art8",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIITassonomiaUEFondiInterniArt8Options,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        53: {sectionName:"SOSTENIBILITA",name:"Presenza Fondi Interni Art. 9 SFDR",fieldName:"ramo_iii_presenza_fondi_interni_art9_sfdr",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIIPresenzaFondiInterniArt9SFDROptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        54: {sectionName:"SOSTENIBILITA",name:"N° Fondi Interni Art. 9 SFDR",fieldName:"ramo_iii_num_fondi_interni_art9_sfdr",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIINumFondiInterniArt9SFDRProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_num_fondi_interni_art9_sfdr:"Min.   Media   Max.",},isSelected:true},
        55: {sectionName:"SOSTENIBILITA",name:"Fondi Interni Art. 9 SFDR (%)",fieldName:"ramo_iii_fondi_interni_art9_sfdr_perc",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIIFondiInterniArt9SFDRPercProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_fondi_interni_art9_sfdr_perc:"Min.   Media   Max.",},isSelected:true},
        56: {sectionName:"SOSTENIBILITA",name:"Tassonomia UE Fondi Interni Art. 9",fieldName:"ramo_iii_tassonomia_ue_fondi_interni_art9",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIITassonomiaUEFondiInterniArt9Options,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        57: {sectionName:"SOSTENIBILITA",name:"PAI Fondi Interni",fieldName:"ramo_iii_pai_fondi_interni",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIIPAIFondiInterniOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        58: {sectionName:"SOSTENIBILITA",name:"Presenza OICR/ETF Art. 8 SFDR",fieldName:"ramo_iii_presenza_oicr_etf_art8_sfdr",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIIPresenzaOICRETFArt8SFDROptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        59: {sectionName:"SOSTENIBILITA",name:"N° OICR/ETF Art. 8 SFDR",fieldName:"ramo_iii_num_oicr_etf_art8_sfdr",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIINumOICRETFArt8SFDRProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_num_oicr_etf_art8_sfdr:"Min.   Media   Max.",},isSelected:true},
        60: {sectionName:"SOSTENIBILITA",name:"OICR/ETF Art. 8 SFDR (%)",fieldName:"ramo_iii_oicr_etf_art8_sfdr_perc",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIIOICRETFArt8SFDRPercProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_oicr_etf_art8_sfdr_perc:"Min.   Media   Max.",},isSelected:true},
        61: {sectionName:"SOSTENIBILITA",name:"Tassonomia UE OICR/ETF Art. 8",fieldName:"ramo_iii_tassonomia_ue_oicr_etf_art8",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIITassonomiaUEOICRETFArt8Options,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        62: {sectionName:"SOSTENIBILITA",name:"Presenza OICR/ETF Art. 9 SFDR",fieldName:"ramo_iii_presenza_oicr_etf_art9_sfdr",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIIPresenzaOICRETFArt9SFDROptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        63: {sectionName:"SOSTENIBILITA",name:"N° OICR/ETF Art. 9 SFDR",fieldName:"ramo_iii_num_oicr_etf_art9_sfdr",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIINumOICRETFArt9SFDRProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_num_oicr_etf_art9_sfdr:"Min.   Media   Max.",},isSelected:true},
        64: {sectionName:"SOSTENIBILITA",name:"OICR/ETF Art. 9 SFDR (%)",fieldName:"ramo_iii_oicr_etf_art9_sfdr_perc",chartType:chart_type_categories.GROUPED_BAR_CHART,code:properties.ramoIIIOICRETFArt9SFDRPercProperty.code,options:undefined,sortingMethod:undefined,queryType:query_type_categories.STANDARD_FOR_MIN_MAX,fasce:undefined,legendMapping:undefined,fieldNameMapping:{ramo_iii_oicr_etf_art9_sfdr_perc:"Min.   Media   Max.",},isSelected:true},
        65: {sectionName:"SOSTENIBILITA",name:"Tassonomia UE OICR/ETF Art. 9",fieldName:"ramo_iii_tassonomia_ue_oicr_etf_art9",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIITassonomiaUEOICRETFArt9Options,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
        66: {sectionName:"SOSTENIBILITA",name:"PAI OICR/ETF",fieldName:"ramo_iii_pai_oicr_etf",chartType:chart_type_categories.BAR_CHART,code:undefined,options:data.ramoIIIPAIOICRETFOptions,sortingMethod:sorting_methods_categories.ISSUES_CODE_COMPARE,queryType:query_type_categories.COUNT,fasce:undefined,legendMapping:undefined,isSelected:true},
      } as any,
      jquery,
    };
  },
  /*computed: {
    selectedCharts: function () {
      const vm = this as any;

      let selectedMapIndexSlide = {};
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if ((value as any).isSelected) {
          console.log(" key = " + key);
          selectedMapIndexSlide[key] = value as any;
        }
      }

      return selectedMapIndexSlide;
    }
  }*/
  methods: {
    storeFilter: function(filter: any, saveViewState: boolean) {
      let viewState: any = {
        slide: this.slide,
        mapIndexSlide: this.mapIndexSlide
      };
      var f: Filter = {
        id: FILTER_KEY,
        payload: filter !== undefined ? filter : this.filtroRicerca,
        changedFields: this.changedFilterFields,
        viewState: saveViewState ? viewState : {},
      }
      this.$store.dispatch('filters/set', f);
    },
    getStoredFilter: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.payload;
    },
    getStoredChangedFields: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.changedFields;
    },
    getStoredViewState: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.viewState;
    },
    prev() {
      const vm = this as any;

      //vm.$refs.chartsCarousel.prev();
      const prevSelectedSlideIndex = vm.getPrevIsSelectedSlideIndex();
      vm.$refs.chartsCarousel.setSlide(prevSelectedSlideIndex);
    },
    next() {
      const vm = this as any;

      //vm.$refs.chartsCarousel.next();
      const nextSelectedSlideIndex = vm.getNextIsSelectedSlideIndex();
      vm.$refs.chartsCarousel.setSlide(nextSelectedSlideIndex);
    },
    filterDB: function(field: any) {
      const vm = this as any;
      if (field !== undefined) {
        let f: any = clone(vm.filtroRicercaDB);
        f = merge(f, vm.filtroRicerca);
        let k = field.key;
        let v = field.value;
        let vs = field.values;
        let min = field.min;
        let max = field.max;
        let avg = field.avg;
        let tot = field.tot;
        let count = field.count;
        let barName = field.barName;
        let barValue = field.barValue;
        let exclusive = undefined;
        let ignores = [];
        let a: any = Object.values(vm.mapIndexSlide).filter((el: any) => {
          return el.fieldName == k;
        });
        if ((a == undefined || a.length == 0) && v != undefined && v.code != undefined) {
          a = Object.values(vm.mapIndexSlide).filter((el: any) => {
            return el.code == v.code;
          });
        }
        let fasce = undefined;
        if (a != undefined && a.length == 1) {
          fasce = a[0].fasce;
          ignores = a[0].xExclude;
        }
        if (k == "tipologiaSottostantiCombinazione") {
          v.code = properties.tipologiaSottostantiProperty.code;
          v.description = v.description.replaceAll(' + ', '|');
          exclusive = true;
        }
        if (k == "inizioComm") {
          k = "inizioCommercializzazioneDaDate";
          v = vm.dateFromString("01/01/" + field.value.description);
          f[k] = v;
          k = "inizioCommercializzazioneADate";
          v = vm.dateFromString("31/12/" + field.value.description);
          f[k] = v;
        }
        if (v !== undefined) {
          if (v.code == "82" && (min !== undefined || max !== undefined || avg !== undefined || tot != undefined)) {
            k = "bonusIngressoStatistiche";
          }
          if (v.code == "84" && tot != undefined) {
            k = "bonusFedeltaStatistiche";
          }
          if (v.code == "87" && (min !== undefined || max !== undefined || avg !== undefined || tot != undefined)) {
            k = "caricamentoPICStatistiche";
          }
          if (v.code == "89" && (min !== undefined || max !== undefined || avg !== undefined || tot != undefined)) {
            k = "caricamentoPACStatistiche";
          }
          if (v.code == "92" && (min !== undefined || max !== undefined || avg !== undefined)) {
            k = "commissioneGestioneSeparataStatistiche";
          }
        }
        if (k == "commissioneFondiInterniStatistichePerTipologiaFondo") {
          const d = v.description;
          if (d == "Fondi Interni Azionari") {
            v.code = properties.commissioneFondiInterniAzionariProperty.code;
          }
          if (d == "Fondi Interni Obbligazionari") {
            v.code = properties.commissioneFondiInterniObbligazionariProperty.code;
          }
          if (d == "Fondi Interni Bilanciati") {
            v.code = properties.commissioneFondiInterniBilanciatiProperty.code;
          }
          if (d == "Fondi Interni Flessibili") {
            v.code = properties.commissioneFondiInterniFlessibiliProperty.code;
          }
          if (d == "Fondi Interni Monetari") {
            v.code = properties.commissioneFondiInterniMonetariProperty.code;
          }
        }
        if (k == "spese_gestione_polizza") {
          const d = v.description;
          if (d == "Spese Gestione Polizza OICR/ETF Azionari") {
            v.code = properties.speseGestionePolizzaOICRETFAzionariProperty.code;
          }
          if (d == "Spese Gestione Polizza OICR/ETF Obbligazionari") {
            v.code = properties.speseGestionePolizzaOICRETFObbligazionariProperty.code;
          }
          if (d == "Spese Gestione Polizza OICR/ETF Bilanciati") {
            v.code = properties.speseGestionePolizzaOICRETFBilanciatiProperty.code;
          }
          if (d == "Spese Gestione Polizza OICR/ETF Flessibili") {
            v.code = properties.speseGestionePolizzaOICRETFFlessibiliProperty.code;
          }
          if (d == "Spese Gestione Polizza OICR/ETF Monetari") {
            v.code = properties.speseGestionePolizzaOICRETFMonetariProperty.code;
          }
        }
        if (v !== undefined) {
          if (v.code == "110" && tot !== undefined) {
            k = "applicazioneCommissioniUscita";
          }
        }
        if (k == "commissioniUscitaStatistichePerAnno") {
          v.code = properties.commissioniUscitaProperty.code;
        }
        if (fasce) {
          let r = fasce.filter((i: [string]) => {
            return i[0] == field.value.description;
          });
          if (r != undefined && r.length == 1) {
            if (k == "importo_minimo_premio_unico") {
              if (r[0][0] == "Non indicato") {
                k = "impMinPremioUnicoDa";
                v = "-1";
                f[k] = v;
                k = "impMinPremioUnicoA";
                v = "-1";
                f[k] = v;                
              } else {
                k = "impMinPremioUnicoDa";
                v = r[0][1];
                f[k] = v;
                k = "impMinPremioUnicoA";
                v = r[0][2];
                f[k] = v;
              }
            } else if (k == "importo_minimo_premio_ricorrente") {
              if (r[0][0] == "Non indicato") {
                k = "impMinPremioRicorrenteDa";
                v = "-1";
                f[k] = v;
                k = "impMinPremioRicorrenteA";
                v = "-1";
                f[k] = v;                
              } else {
                k = "impMinPremioRicorrenteDa";
                v = r[0][1];
                f[k] = v;
                k = "impMinPremioRicorrenteA";
                v = r[0][2];
                f[k] = v;
              }
            } else {
              if (r[0].length >= 3) {
                min = r[0][1];
                max = r[0][2];
              } else {
                v.description = r[0][0];
                min = undefined;
                max = undefined;
              }
            }
          }
        }

        const filterField = vm.filtroRicerca[k];
        if (f[k] && (filterField == undefined || filterField.length == 0)) {
          f[k] = v || vs;
        } else {
          let code = undefined;
          let description = undefined;
          if (v !== undefined) {
            code = v.code;
            description = v.description;
          } else if (vs != undefined && vs.length == 1) {
            code = vs[0].code;
            description = vs[0].description;
          }
          f.otherField.key = k;
          f.otherField.value = {
            code: code,
            description: description,
            min: min,
            max: max,
            avg: avg,
            tot: tot,
            count: count,
            barName: barName,
            barValue: barValue,
            exclusive: exclusive,
            ignores: ignores,
          };
        }

        vm.storeFilter(vm.filtroRicerca, true);
        vm.$router.push({ name: 'database-vita-investimento', params: { filters: f, fromDashboard: true, user: vm.loggedUser } });
      }
    },
    showFilterPane: function() {
      const vm = this as any;

      vm.showFilter = !vm.showFilter;
    },
    getPrevIsSelectedSlideIndex: function() {
      const vm = this as any;

      let prevSelectedSlideIndex = undefined;
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if (key < vm.slide && (value as any).isSelected) {
          prevSelectedSlideIndex = key;
        } else if (vm.slide == key) {
          break;
        }
      }
      if (prevSelectedSlideIndex === undefined) {
        prevSelectedSlideIndex = vm.slide;
      }

      return prevSelectedSlideIndex;
    },
    getNextIsSelectedSlideIndex: function() {
      const vm = this as any;

      let foundActualSlide = false;
      let nextSelectedSlideIndex = undefined;
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if (vm.slide == key) {
          foundActualSlide = true;
        } else if (key > vm.slide && foundActualSlide && (value as any).isSelected) {
          nextSelectedSlideIndex = key;
          break;
        }
      }
      if (nextSelectedSlideIndex === undefined) {
        nextSelectedSlideIndex = vm.slide;
      }

      return nextSelectedSlideIndex;
    },
    isSelected: function(fieldName: string) {
      const vm = this as any;

      let isSelected = false;
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if ((value as any).name == fieldName) {
          isSelected = (value as any).isSelected;
          break;
        }
      }

      return isSelected;
    },
    changeIsSelected: function(fieldName: string) {
      const vm = this as any;
      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        if (item.name === fieldName) {
          item.isSelected = !item.isSelected;
        }
      });
    },
    changeIsSectionChartsSelected: function(sectionName: string) {
      const vm = this as any;

      vm.isSectionChartsSelected[sectionName] = !vm.isSectionChartsSelected[sectionName];

      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        if (item.sectionName == sectionName) {
          item.isSelected = vm.isSectionChartsSelected[sectionName]
        }
      });
    },
    changeIsAllChartsSelected: function() {
      const vm = this as any;

      vm.isAllChartsSelected = !vm.isAllChartsSelected;

      // imposto tutti i checkbox delle sezioni
      for (const [key, value] of Object.entries(vm.isSectionChartsSelected)) {
        vm.isSectionChartsSelected[key] = vm.isAllChartsSelected;
        //console.log(`${key}: ${value}`);
      }
      // imposto tutti i checkbox dei singoli grafici
      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        item.isSelected = vm.isAllChartsSelected
      });
    },
    resetIsAllChartsSelected: function() {
      const vm = this as any;

      vm.isAllChartsSelected = true;

      // imposto tutti i checkbox delle sezioni
      for (const [key, value] of Object.entries(vm.isSectionChartsSelected)) {
        vm.isSectionChartsSelected[key] = vm.isAllChartsSelected;
        //console.log(`${key}: ${value}`);
      }
      // imposto tutti i checkbox dei singoli grafici
      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        item.isSelected = vm.isAllChartsSelected
      });
    },
    // Si assume che i grafici siano ordinati con un progressivo senza salti di numerazione da 0 ad n, altrimenti non funziona.
    getSlidesIndexByName: function() {
      const vm = this as any;

      Object.values(vm.mapIndexSlide).forEach((item: any) => {
        vm.chartNamesArray.push(item.name);
      });
    },
    resetFilterOptions: async function() {
      const vm = this as any;

      vm.filterOptions.compagnia = vm.compagnieOptions;
      vm.filterOptions.mercato = vm.mercatoOptions;
      vm.filterOptions.canale = vm.canaleOptions;
      vm.filterOptions.distributori = vm.distributoriOptions;
      vm.filterOptions.tipologiaProdotto = vm.tipologiaProdottoOptions;
      vm.filterOptions.tipologiaSottostanti = vm.tipologiaSottostantiOptions;
      vm.filterOptions.prodottoInCommercio = vm.yesNoOptions;
      vm.filterOptions.tipologiaPremio = vm.tipologiaPremioOptions;
    },
    emptyNoDynamicFiltroRicerca: async function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
      vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.fineCommercializzazioneADate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
      vm.filtroRicerca.inizioCommercializzazioneA = undefined;
      vm.filtroRicerca.fineCommercializzazioneDa = undefined;
      vm.filtroRicerca.fineCommercializzazioneA = undefined;
      vm.filtroRicerca.impMinPremioUnicoDa = undefined;
      vm.filtroRicerca.impMinPremioUnicoA = undefined;
      vm.filtroRicerca.impMinPremioRicorrenteDa = undefined;
      vm.filtroRicerca.impMinPremioRicorrenteA = undefined;
    },
    emptyFilterOptions: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filterOptions.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filterOptions.mercato = [];
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filterOptions.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filterOptions.distributori = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaProdotto') ||
          vm.changedFilterFields.indexOf('tipologiaProdotto') > indexOfChangedField) {
        vm.filterOptions.tipologiaProdotto = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaSottostanti') ||
          vm.changedFilterFields.indexOf('tipologiaSottostanti') > indexOfChangedField) {
        vm.filterOptions.tipologiaSottostanti = [];
      }      
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filterOptions.prodottoInCommercio = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaPremio') ||
          vm.changedFilterFields.indexOf('tipologiaPremio') > indexOfChangedField) {
        vm.filterOptions.tipologiaPremio = [];
      }
    },
    emptyFiltroRicerca: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filtroRicerca.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filtroRicerca.mercato = [];
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filtroRicerca.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filtroRicerca.distributori = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaProdotto') ||
          vm.changedFilterFields.indexOf('tipologiaProdotto') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaProdotto = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaSottostanti') ||
          vm.changedFilterFields.indexOf('tipologiaSottostanti') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaSottostanti = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filtroRicerca.prodottoInCommercio = null;
      }
      if (!vm.changedFilterFields.includes('tipologiaPremio') ||
          vm.changedFilterFields.indexOf('tipologiaPremio') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaPremio = [];
      }
    },
    emptyChangedFilterFields() {
      const vm = this as any;

      vm.changedFilterFields = [];
    },
    onFilterSearchClick() {
      const vm = this as any;

      vm.showFilter = false;

      // si attiva il primo grafico selezionato
      for (const [key, value] of Object.entries(vm.mapIndexSlide)) {
        if ((value as any).isSelected) {
          vm.slide = parseInt(key);
          break;
        }
      }

      vm.onSlideStart(vm.slide);
    },
    resetFilterOptionsAndEmptyFiltroRicerca() {
      const vm = this as any;

      vm.resetFilterOptions();
      vm.emptyNoDynamicFiltroRicerca();
      vm.emptyFiltroRicerca(-1);
      vm.emptyChangedFilterFields();
      vm.resetIsAllChartsSelected();
      vm.storeFilter();
    },
    repopulateFiltersOptionsChangedCompagnia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('compagnia');
    },
    repopulateFiltersOptionsChangedMercato: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('mercato');
    },
    repopulateFiltersOptionsChangedDistributori: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('distributori');
    },
    repopulateFiltersOptionsChangedCanale: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('canale');
    },
    repopulateFiltersOptionsChangedTipologiaProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaProdotto');
    },
    repopulateFiltersOptionsChangedTipologiaSottostanti: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaSottostanti');
    },
    repopulateFiltersOptionsChangedTipologiaPremio: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaPremio');
    },
    repopulateFiltersOptions: async function(changedFieldName: string) {
      const vm = this as any;

      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean

      // mantenere l'ordine!
      if (!vm.changedFilterFields.includes(changedFieldName)) {
        vm.changedFilterFields.push(changedFieldName);
      }
      const indexOfChangedField = vm.changedFilterFields.indexOf(changedFieldName)
      vm.emptyFilterOptions(indexOfChangedField);
      vm.emptyFiltroRicerca(indexOfChangedField);
      if (indexOfChangedField + 1 < vm.changedFilterFields.length) {
        vm.changedFilterFields.splice(indexOfChangedField+1, (vm.changedFilterFields.length-indexOfChangedField+1));
      }
      if (vm.filtroRicerca[changedFieldName] === undefined ||
          vm.filtroRicerca[changedFieldName] === null ||
          vm.filtroRicerca[changedFieldName].length == 0) {
        vm.changedFilterFields.pop();
      }
      //console.log(JSON.stringify(vm.filtroRicerca[changedFieldName]));
      //console.log(indexOfChangedField  + " " + changedFieldName + " vm.changedFilterFields " + JSON.stringify(vm.changedFilterFields));

      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {

              // Compagnia
              if (!vm.changedFilterFields.includes('compagnia') ||
                  vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
                let filterCompagniaOption = vm.listaProdottiCensiti[i].properties[3];
                vm.pushOptionValue(filterCompagniaOption,vm.filterOptions.compagnia);
              }

              // Mercato
              if (!vm.changedFilterFields.includes('mercato') ||
                  vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
                let filterMercatoOption = vm.listaProdottiCensiti[i].properties[4];
                vm.pushOptionValues(filterMercatoOption,vm.filterOptions.mercato);
              }

              // Canale
              if (!vm.changedFilterFields.includes('canale') ||
                  vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
                let filterCanaleOption = vm.listaProdottiCensiti[i].properties[5];
                vm.pushOptionValues(filterCanaleOption,vm.filterOptions.canale);
              }

              // Distributori
              if (!vm.changedFilterFields.includes('distributori') ||
                  vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
                let filterDistributoriOption = vm.listaProdottiCensiti[i].properties[6];
                vm.pushOptionStringList(filterDistributoriOption,vm.filterOptions.distributori,'distributori');
              }

              // Tipologia prodotto
              if (!vm.changedFilterFields.includes('tipologiaProdotto') ||
                  vm.changedFilterFields.indexOf('tipologiaProdotto') > indexOfChangedField) {
                let filterTipologiaProdottoOption = vm.listaProdottiCensiti[i].properties[7];
                vm.pushOptionValue(filterTipologiaProdottoOption,vm.filterOptions.tipologiaProdotto);
              }

              // Tipologia sottostanti
              if (!vm.changedFilterFields.includes('tipologiaSottostanti') ||
                  vm.changedFilterFields.indexOf('tipologiaSottostanti') > indexOfChangedField) {
                let filterTipologiaSottostantiOption = vm.listaProdottiCensiti[i].properties[8];
                vm.pushOptionValues(filterTipologiaSottostantiOption,vm.filterOptions.tipologiaSottostanti);
              }

              // Prodotto in commercio
              if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
                  vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
                let filterProdottoInCommercioOption = { code : (vm.listaProdottiCensiti[i].properties[9].code == "8.1" ? true : false) , value : vm.listaProdottiCensiti[i].properties[9].value };
                vm.pushOptionValue(filterProdottoInCommercioOption,vm.filterOptions.prodottoInCommercio);
              }

              // Tipologia premio
              if (!vm.changedFilterFields.includes('tipologiaPremio') ||
                  vm.changedFilterFields.indexOf('tipologiaPremio') > indexOfChangedField) {
                let filterTipologiaPremioOption = vm.listaProdottiCensiti[i].properties[13];
                vm.pushOptionValue(filterTipologiaPremioOption,vm.filterOptions.tipologiaPremio);
              }
            }
          }

          return null;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    homeProdotti: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      vm.$router.go(-1);
    },
    isAdmin: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0;
      }
      return false;
    },
    isAdvanced: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('advanced') >= 0;
      }
      return false;
    },
    getCodeFromDescription(description: string, options: any) {
      let code = undefined;

      options.forEach(function(option: any) {
        if (option.description == description) {
          code = option.code;
          return;
        }
      });

      return code;
    },
    getDescriptionFromCode(code: string, options: any) {
      let description = undefined;

      options.forEach(function(option: any) {
        if (option.code == code) {
          description = option.description;
          return;
        }
      });

      return description;
    },
    onSlideStartCompagnia() {
      const vm = this as any;

      vm.isCheckedCompagnia = !vm.isCheckedCompagnia;

      vm.onSlideStart();
    },
    onSlideStartDistributori() {
      const vm = this as any;

      vm.isCheckedDistributori = !vm.isCheckedDistributori;

      vm.onSlideStart();
    },
    onSlideStartTipologiaProdotto() {
      const vm = this as any;

      vm.isCheckedTipologiaProdotto = !vm.isCheckedTipologiaProdotto;

      vm.onSlideStart();
    },
    onSlideStartSostenibilita() {
      const vm = this as any;

      vm.isCheckedSostenibilita = !vm.isCheckedSostenibilita;

      vm.onSlideStart();
    },
    onSlideStartRamoISFDR() {
      const vm = this as any;

      vm.isCheckedRamoISFDR = !vm.isCheckedRamoISFDR;

      vm.onSlideStart();
    },
    onSlideStartRamoITassonomiaUE() {
      const vm = this as any;

      vm.isCheckedRamoITassonomiaUE = !vm.isCheckedRamoITassonomiaUE;

      vm.onSlideStart();
    },
    onSlideStartRamoIPAI() {
      const vm = this as any;

      vm.isCheckedRamoIPAI = !vm.isCheckedRamoIPAI;

      vm.onSlideStart();
    },
    onSlideStartRamoIIIPresenzaFondiInterniArt8SFDR() {
      const vm = this as any;

      vm.isCheckedRamoIIIPresenzaFondiInterniArt8SFDR = !vm.isCheckedRamoIIIPresenzaFondiInterniArt8SFDR;

      vm.onSlideStart();
    },
    onSlideStartRamoIIITassonomiaUEFondiInterniArt8() {
      const vm = this as any;

      vm.isCheckedRamoIIITassonomiaUEFondiInterniArt8 = !vm.isCheckedRamoIIITassonomiaUEFondiInterniArt8;

      vm.onSlideStart();
    },
    onSlideStartRamoIIIPresenzaFondiInterniArt9SFDR() {
      const vm = this as any;

      vm.isCheckedRamoIIIPresenzaFondiInterniArt9SFDR = !vm.isCheckedRamoIIIPresenzaFondiInterniArt9SFDR;

      vm.onSlideStart();
    },
    onSlideStartRamoIIITassonomiaUEFondiInterniArt9() {
      const vm = this as any;

      vm.isCheckedRamoIIITassonomiaUEFondiInterniArt9 = !vm.isCheckedRamoIIITassonomiaUEFondiInterniArt9;

      vm.onSlideStart();
    },
    onSlideStartRamoIIIPAIFondiInterni() {
      const vm = this as any;

      vm.isCheckedRamoIIIPAIFondiInterni = !vm.isCheckedRamoIIIPAIFondiInterni;

      vm.onSlideStart();
    },
    onSlideStartRamoIIIPresenzaOICRETFArt8SFDR() {
      const vm = this as any;

      vm.isCheckedRamoIIIPresenzaOICRETFArt8SFDR = !vm.isCheckedRamoIIIPresenzaOICRETFArt8SFDR;

      vm.onSlideStart();
    },
    onSlideStartRamoIIITassonomiaUEOICRETFArt8() {
      const vm = this as any;

      vm.isCheckedRamoIIITassonomiaUEOICRETFArt8 = !vm.isCheckedRamoIIITassonomiaUEOICRETFArt8;

      vm.onSlideStart();
    },
    onSlideStartRamoIIIPresenzaOICRETFArt9SFDR() {
      const vm = this as any;

      vm.isCheckedRamoIIIPresenzaOICRETFArt9SFDR = !vm.isCheckedRamoIIIPresenzaOICRETFArt9SFDR;

      vm.onSlideStart();
    },
    onSlideStartRamoIIINumOICRETFArt9SFDR() {
      const vm = this as any;

      vm.isCheckedRamoIIINumOICRETFArt9SFDR = !vm.isCheckedRamoIIINumOICRETFArt9SFDR;

      vm.onSlideStart();
    },
    onSlideStartRamoIIIOICRETFArt9SFDRPerc() {
      const vm = this as any;

      vm.isCheckedRamoIIIOICRETFArt9SFDRPerc = !vm.isCheckedRamoIIIOICRETFArt9SFDRPerc;

      vm.onSlideStart();
    },
    onSlideStartRamoIIITassonomiaUEOICRETFArt9() {
      const vm = this as any;

      vm.isCheckedRamoIIITassonomiaUEOICRETFArt9 = !vm.isCheckedRamoIIITassonomiaUEOICRETFArt9;

      vm.onSlideStart();
    },
    onSlideStartRamoIIIPAIOICRETF() {
      const vm = this as any;

      vm.isCheckedRamoIIIPAIOICRETF = !vm.isCheckedRamoIIIPAIOICRETF;

      vm.onSlideStart();
    },

    onSlideStart: async function(slide: any) {
      const vm = this as any;

      if (vm.actualSlide == slide && slide != 0) {
        return;
      }

      jquery(".control-tooltip").hide();

      const fieldNamesSeparator = ",";

      vm.sliding = true

      //...toppa da risolvere con metodo a parte...
      if (typeof(slide) === 'number') {
        vm.actualSlide = slide;
      } else {
        slide = vm.actualSlide; //utilizzo da pulsante CERCA
      }

      vm.models = [];

      vm.setDatePropertiesValue();

      const fieldName = vm.mapIndexSlide[slide].fieldName;
      const fieldNames = fieldName.split(fieldNamesSeparator);
      const chartType = vm.mapIndexSlide[slide].chartType;
      const queryType = vm.mapIndexSlide[slide].queryType;
      const xExclude = vm.mapIndexSlide[slide].xExclude;
      const code = vm.mapIndexSlide[slide].code;
      const options = vm.mapIndexSlide[slide].options;
      const sortingMethodStr = vm.mapIndexSlide[slide].sortingMethod;
      const fasce = vm.mapIndexSlide[slide].fasce;
      const legendMapping = vm.mapIndexSlide[slide].legendMapping;
      const fieldNameMapping = vm.mapIndexSlide[slide].fieldNameMapping;
      let otherOptions = vm.mapIndexSlide[slide].otherOptions;
      const statistics = vm.mapIndexSlide[slide].statistics;
      const statisticsTypes = vm.mapIndexSlide[slide].statisticsTypes;
      const statisticsLabelsMapping = vm.mapIndexSlide[slide].statisticsLabelsMapping;
      const statisticsParams = vm.mapIndexSlide[slide].statisticsParams;
      //const sortingMethod = vm.getSortingMethod(sortingMethodStr);

      // per alcuni campi occorrono degli adattamenti per fare in modo che il filtro sia corretto per il backend
      vm.storeFilter(vm.filtroRicerca, false);
      vm.filtroRicercaAdapted = clone(vm.filtroRicerca);
      vm.filtroRicercaAdapted.prodottoInCommercio = undefined;
      if (vm.filtroRicerca.prodottoInCommercio !== undefined) {
        if (vm.filtroRicerca.prodottoInCommercio == true) {
          vm.filtroRicercaAdapted.prodottoInCommercio = "Sì";
        } else if (vm.filtroRicerca.prodottoInCommercio == false) {
          vm.filtroRicercaAdapted.prodottoInCommercio = "No";
        } 
        if (vm.filtroRicercaAdapted.prodottoInCommercio === undefined) {
          vm.filtroRicercaAdapted.prodottoInCommercio = vm.getDescriptionFromCode(vm.filtroRicerca.prodottoInCommercio, data.yesNoOptions);
        }
      }

      //
      let iMap = null as any;

      let params = [] as any;
      if (otherOptions === undefined || otherOptions === null) {
        otherOptions = [];
      }
      fieldNames.forEach(function(fieldName: string) {
        let isChecked = false;
        switch (fieldName) {
          case 'compagnia':
            isChecked = vm.isCheckedCompagnia;
            break;
          case 'distributori':
            isChecked = vm.isCheckedDistributori;
            break;
          case 'tipologia_prodotto':
            isChecked = vm.isCheckedTipologiaProdotto;
            break;
          case 'sostenibilita':
            isChecked = vm.isCheckedSostenibilita;
            break;
          case 'ramo_i_sfdr':
            isChecked = vm.isCheckedRamoISFDR;
            break;
          case 'ramo_i_tassonomia_ue':
            isChecked = vm.isCheckedRamoITassonomiaUE;
            break;
          case 'ramo_i_pai':
            isChecked = vm.isCheckedRamoIPAI;
            break;
          case 'ramo_iii_presenza_fondi_interni_art8_sfdr':
            isChecked = vm.isCheckedRamoIIIPresenzaFondiInterniArt8SFDR;
            break;
          case 'ramo_iii_tassonomia_ue_fondi_interni_art8':
            isChecked = vm.isCheckedRamoIIITassonomiaUEFondiInterniArt8;
            break;
          case 'ramo_iii_presenza_fondi_interni_art9_sfdr':
            isChecked = vm.isCheckedRamoIIIPresenzaFondiInterniArt9SFDR;
            break;
          case 'ramo_iii_tassonomia_ue_fondi_interni_art9':
            isChecked = vm.isCheckedRamoIIITassonomiaUEFondiInterniArt9;
            break;
          case 'ramo_iii_pai_fondi_interni':
            isChecked = vm.isCheckedRamoIIIPAIFondiInterni;
            break;
          case 'ramo_iii_presenza_oicr_etf_art8_sfdr':
            isChecked = vm.isCheckedRamoIIIPresenzaOICRETFArt8SFDR;
            break;
          case 'ramo_iii_tassonomia_ue_oicr_etf_art8':
            isChecked = vm.isCheckedRamoIIITassonomiaUEOICRETFArt8;
            break;
          case 'ramo_iii_tassonomia_ue_oicr_etf_art8':
            isChecked = vm.isCheckedRamoIIITassonomiaUEOICRETFArt8;
            break;
          case 'ramo_iii_presenza_oicr_etf_art9_sfdr':
            isChecked = vm.isCheckedRamoIIIPresenzaOICRETFArt9SFDR;
            break;
          case 'ramo_iii_tassonomia_ue_oicr_etf_art9':
            isChecked = vm.isCheckedRamoIIITassonomiaUEOICRETFArt9;
            break;
          case 'ramo_iii_pai_oicr_etf':
            isChecked = vm.isCheckedRamoIIIPAIOICRETF;
            break;
        }
        if (isChecked) {
          otherOptions.push("prodotti_collegati_as_one");
        }
        params.push({fieldName:fieldName,queryType:queryType,xExclude:xExclude,sortingMethod:sortingMethodStr,dbSearchFilter:vm.filtroRicercaAdapted,category:categories.VITA_INVESTIMENTO,fasce:fasce,legendMapping:legendMapping,fieldNameMapping:fieldNameMapping,otherOptions:otherOptions,isStatistics:statistics,statisticsTypes:statisticsTypes,statisticsLabelsMapping:statisticsLabelsMapping,statisticsParams:statisticsParams});
      });

      const serviceCallReturnValue = await requestService.getDataForChart(params)
        .then(handleResponse)
        .then((result: any) => {
          iMap = result.issuesMap;
          // ordinamento in base a campo fieldName
          let iMapSorted = iMap as any; // iMap viene tornato ordinato già da backend perché è utilizzata LinkedHashMap
          /* -- codice superfluo, serviva per ordinamento quando a backend non era utilizzata LinkedHashMap
          let iMapSorted = {} as any;
          fieldNames.forEach(function(fieldName: string) {
            Object.keys(iMap).forEach(function(fn: string) {
              if (fn == fieldName) {
                iMapSorted[fn] = iMap[fn];
              }
            });
          });*/

          // valorizzazione code in quanto non tornati dal servizio
          /*Object.keys(iMapSorted).forEach(function(fn: string) {
            iMapSorted[fn].forEach(function(issue: any) {
              if (code != undefined) {
                issue.code = code;
              } else {
                issue.code = vm.getCodeFromDescription(issue.description, options);
              }
            });
          });*/

          if (iMapSorted != null) {
            // rielaboro i dati a seconda del tipo di grafico da creare
            if (chart_type_categories.GROUPED_BAR_CHART == chartType) {
              vm.models = [];
              let sortByAlias = false;

              Object.keys(iMapSorted).forEach(function(fn: string) {
                let obj = {} as any;
                obj["model_name"] = fn;

                if (obj["model_name"].startsWith("rendimento_gestione_separata_anno_")) {
                  obj["alias_model_name"] = obj["model_name"].substr(obj["model_name"].length - 4); //solo l'anno
                  sortByAlias = true;
                }

                iMapSorted[fn].forEach((issue: any) => {
                  obj[issue.description] = issue.value;
                });

                console.log(`fieldName=${fieldName}, obj=${JSON.stringify(obj)}`);

                vm.models.push(obj);
              });

              if (sortByAlias) {
                vm.models.sort((a: any, b: any) => {
                  const aliasA = a["alias_model_name"];
                  const aliasB = b["alias_model_name"];
                  return aliasA.localeCompare(aliasB);
                })
              }
            } else {
              /*Object.keys(iMapSorted).forEach(function(fn: string) {
                iMapSorted[fn] = iMapSorted[fn].sort(sortingMethod);
              });*/
              this.issuesMap = iMapSorted;
            }
          }

          return null;
        })
        .catch(function(e) {
          console.log("Error in getDataForChart for field " + JSON.stringify(fieldNames));
        });

      if (statistics) {
        if (statisticsParams !== undefined && statisticsParams !== null) {
          params[0].statisticsParams.dbSearchFilter = vm.filtroRicercaAdapted;
          params[0].statisticsParams.category = categories.VITA_INVESTIMENTO;
        }

        const statisticServiceCallReturnValue = await requestService.getStatisticsForChart(params)
          .then(handleResponse)
          .then((result: any) => {
            this.statisticsMap = result.issuesMap;

            return null;
          })
          .catch(function(e) {
            console.log("Error in getStatisticsDataForChart for field " + JSON.stringify(fieldNames));
          });
      }
    },
    onSlideEnd(slide: any) {
      this.sliding = false
    },
    /* formato:
      this.issues = {
          compagnia: [
            {xVal: "Allianz", xCode: "2.3", issues: 4},
            {xVal: "Cardif", xCode: "2.21", issues: 3},
            ...
          ],
          canale: [
            {xVal: "Banca", xCode: "3.1", issues: 5},
            {xVal: "Consulenti Finanziari", xCode: "3.2", issues: 3},
            ...
          ],
        };
    */
    getStartingIssues() {
      this.onSlideStart(this.slide); // starting sliding at slide 0
    },
    getPropertyValues: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      const serviceCallReturnValue = await requestService.getPropertyValues(vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.prodottiOptions = result.prodotti;
          vm.distributoriOptions = result.distributori;
          vm.compagnieOptions = result.compagnie;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getMinFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let minVal = vm.getOneStatisticFromStatistics(statisticsMapItem, statistics_categories.MIN);

      return minVal;
    },
    getAvgFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let avgVal = vm.getOneStatisticFromStatistics(statisticsMapItem, statistics_categories.AVG);

      return avgVal;
    },
    getMaxFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let maxVal = vm.getOneStatisticFromStatistics(statisticsMapItem, statistics_categories.MAX);

      return maxVal;
    },
    getProductsCountFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let pCountVal = vm.getOneStatisticFromStatistics(statisticsMapItem, statistics_categories.PRODUCTS_COUNT);

      return pCountVal;
    },
    getProductsCountOnTotFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let pCountOnTotVal = vm.getOneStatisticFromStatistics(statisticsMapItem, statistics_categories.PRODUCTS_COUNT_ON_TOT);

      return pCountOnTotVal;
    },
    getSumFromStatistics: function(statisticsMapItem: any) {
      const vm = this as any;

      let pCountOnTotVal = vm.getOneStatisticFromStatistics(statisticsMapItem, statistics_categories.SUM);

      return pCountOnTotVal;
    },
    getOneStatisticFromStatistics: function(statisticsMapItem: any, statisticName: string) {
      let retVal = undefined;

      if (statisticsMapItem !== undefined && statisticsMapItem !== null) {
        statisticsMapItem.forEach((s: any) => {
          if (s.description == statisticName) {
            retVal = s.value;
          }
        });
      }

      return retVal;
    },
    inizializzaFiltroRicerca: function() {
      const vm = this as any;

      const storedFilter = vm.getStoredFilter();
      if (storedFilter == undefined) {
        vm.filtroRicerca.prodottoCompleto = true;
        vm.filtroRicerca.compagnia = [] as any;
        vm.filtroRicerca.mercato = [] as any;
        vm.filtroRicerca.canale = [] as any;
        vm.filtroRicerca.distributori = [] as any;
        vm.filtroRicerca.tipologiaProdotto = [] as any;
        vm.filtroRicerca.tipologiaSottostanti = [] as any;
        vm.filtroRicerca.prodottoInCommercio = null;
        vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
        vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.fineCommercializzazioneADate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
        vm.filtroRicerca.inizioCommercializzazioneA = undefined;
        vm.filtroRicerca.fineCommercializzazioneDa = undefined;
        vm.filtroRicerca.fineCommercializzazioneA = undefined;
        vm.filtroRicerca.tipologiaPremio = [] as any;
        vm.filtroRicerca.impMinPremioUnicoDa = undefined;
        vm.filtroRicerca.impMinPremioUnicoA = undefined;
        vm.filtroRicerca.impMinPremioRicorrenteDa = undefined;
        vm.filtroRicerca.impMinPremioRicorrenteA = undefined;
      } else {
        vm.filtroRicerca = storedFilter;
        const viewState = vm.getStoredViewState();
        if (vm.fromDatabase && viewState != undefined && viewState.slide != undefined && viewState.mapIndexSlide != undefined) {
          vm.slide = viewState.slide;
          vm.mapIndexSlide = viewState.mapIndexSlide;
          vm.showFilter = false;
        }
        var f: Filter = {
          id: FILTER_KEY,
          payload: vm.filtroRicerca,
          changedFields: vm.getStoredChangedFields(),
          viewState: {},
        }
        this.$store.dispatch('filters/set', f);
      }

      const storedChangedFields = vm.getStoredChangedFields();
      if (storedChangedFields != undefined) {
        vm.changedFilterFields = storedChangedFields;
      } else {
        vm.emptyChangedFilterFields();
      }
    },
    pushOptionValue(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value) && filterOptionToInsert.value != vm.ND) {
        filter.push({ code : filterOptionToInsert.code , description : filterOptionToInsert.value })
      }
    },
    pushOptionValues(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      filterOptionToInsert.values.forEach((v: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.code == v.code && o.description == v.description) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent) {
          filter.push({ code : v.code , description : v.description })
        }
      });
    },
    pushOptionStringList(filterOptionToInsert: any, filter: any, fieldName: string) {
      const vm = this as any;

      filterOptionToInsert.stringList.forEach((s: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.description == s.value) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent && !vm.isEmptyOrSpaces(s.value)) {
          let index = filter.length;
          filter.push({ code : categories.VITA_INVESTIMENTO + "-" + fieldName + "-" + index, description : s.value });
        }
      });
    },
    /*
      const statistics = vm.mapIndexSlide[slide].statistics;
      const statisticsParams = vm.mapIndexSlide[slide].statisticsParams;
    */
    exportChartData: async function(fileFormat: string, flagExportAll: boolean) {
      const vm = this as any;
      vm.startLoading();

      const fieldNamesSeparator = ",";

      let params = [] as any;
      if (flagExportAll !== true) {
        const fieldName = vm.mapIndexSlide[vm.actualSlide].fieldName;
        const fieldNames = fieldName.split(fieldNamesSeparator);
        const queryType = vm.mapIndexSlide[vm.actualSlide].queryType;
        const chartType = vm.mapIndexSlide[vm.actualSlide].chartType;
        const chartName = vm.mapIndexSlide[vm.actualSlide].name;
        const xExclude = vm.mapIndexSlide[vm.actualSlide].xExclude;
        const sortingMethodStr = vm.mapIndexSlide[vm.actualSlide].sortingMethod;
        const fasce = vm.mapIndexSlide[vm.actualSlide].fasce;
        const legendMapping = vm.mapIndexSlide[vm.actualSlide].legendMapping;
        const fieldNameMapping = vm.mapIndexSlide[vm.actualSlide].fieldNameMapping;
        let otherOptions = vm.mapIndexSlide[vm.actualSlide].otherOptions;
        const statistics = vm.mapIndexSlide[vm.actualSlide].statistics;
        const statisticsTypes = vm.mapIndexSlide[vm.actualSlide].statisticsTypes;
        const statisticsLabelsMapping = vm.mapIndexSlide[vm.actualSlide].statisticsLabelsMapping;
        const statisticsParams = vm.mapIndexSlide[vm.actualSlide].statisticsParams;

        if (statisticsParams !== undefined && statisticsParams !== null) {
          statisticsParams.dbSearchFilter = vm.filtroRicercaAdapted;
          statisticsParams.category = categories.VITA_INVESTIMENTO;
        }

        fieldNames.forEach(function(fieldName: string) {
          if ((fieldName == 'compagnia' && vm.isCheckedCompagnia) ||
              (fieldName == 'distributori' && vm.isCheckedDistributori) ||
              (fieldName == 'tipologia_prodotto' && vm.isCheckedTipologiaProdotto)) {
            if (otherOptions === undefined || otherOptions === null) {
              otherOptions = [];
            }
            otherOptions.push("prodotti_collegati_as_one");
          }
          params.push({fieldName:fieldName,queryType:queryType,xExclude:xExclude,sortingMethod:sortingMethodStr,dbSearchFilter:vm.filtroRicercaAdapted,category:categories.VITA_INVESTIMENTO,chartType:chartType,chartName:chartName,fasce:fasce,legendMapping:legendMapping,fieldNameMapping:fieldNameMapping,otherOptions:otherOptions,isStatistics:statistics,statisticsTypes:statisticsTypes,statisticsLabelsMapping:statisticsLabelsMapping,statisticsParams:statisticsParams});
        });
      } else {
        Object.keys(vm.mapIndexSlide).forEach(function(slideIndex: any) {
          if (vm.mapIndexSlide[slideIndex].isSelected) {
            const fieldName = vm.mapIndexSlide[slideIndex].fieldName;
            const fieldNames = fieldName.split(fieldNamesSeparator);
            const queryType = vm.mapIndexSlide[slideIndex].queryType;
            const chartType = vm.mapIndexSlide[slideIndex].chartType;
            const chartName = vm.mapIndexSlide[slideIndex].name;
            const xExclude = vm.mapIndexSlide[slideIndex].xExclude;
            const sortingMethodStr = vm.mapIndexSlide[slideIndex].sortingMethod;
            const fasce = vm.mapIndexSlide[slideIndex].fasce;
            const legendMapping = vm.mapIndexSlide[slideIndex].legendMapping;
            const fieldNameMapping = vm.mapIndexSlide[slideIndex].fieldNameMapping;
            let otherOptions = vm.mapIndexSlide[slideIndex].otherOptions;
            const statistics = vm.mapIndexSlide[slideIndex].statistics;
            const statisticsTypes = vm.mapIndexSlide[slideIndex].statisticsTypes;
            const statisticsLabelsMapping = vm.mapIndexSlide[slideIndex].statisticsLabelsMapping;
            const statisticsParams = vm.mapIndexSlide[slideIndex].statisticsParams;
  
            if (statisticsParams !== undefined && statisticsParams !== null) {
              statisticsParams.dbSearchFilter = vm.filtroRicercaAdapted;
              statisticsParams.category = categories.VITA_INVESTIMENTO;
            }
  
            fieldNames.forEach(function(fieldName: string) {
              if ((fieldName == 'compagnia' && vm.isCheckedCompagnia) ||
                  (fieldName == 'distributori' && vm.isCheckedDistributori) ||
                  (fieldName == 'tipologia_prodotto' && vm.isCheckedTipologiaProdotto)) {
                if (otherOptions === undefined || otherOptions === null) {
                  otherOptions = [];
                }
                otherOptions.push("prodotti_collegati_as_one");
              }            
              params.push({fieldName:fieldName,queryType:queryType,xExclude:xExclude,sortingMethod:sortingMethodStr,dbSearchFilter:vm.filtroRicercaAdapted,category:categories.VITA_INVESTIMENTO,chartType:chartType,chartName:chartName,fasce:fasce,legendMapping:legendMapping,fieldNameMapping:fieldNameMapping,otherOptions:otherOptions,isStatistics:statistics,statisticsTypes:statisticsTypes,statisticsLabelsMapping:statisticsLabelsMapping,statisticsParams:statisticsParams});
            });
          }
        });
      }

      let contentType = '';
      let fileName = '';
      const filtro = vm.filtroRicerca;
      const serviceCallReturnValue = await requestService
        .extractChartData(params,fileFormat)
        .then((response: any) => {
          const headerContentType = response.headers.get("content-type");
          contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
          return response.blob();
        })
        .then((blob: any) => {
          fileName = 'chart-data-export.' + fileFormat;          
          vm.downloadDocFromBlob(blob, fileName, contentType);
        })
        .catch((e) => {
          console.log(e);
          vm.openModalError("Errore generico");
        })

      vm.stopLoading();
    },
    exportChartDataCsv: async function() {
      const vm = this as any;

      vm.exportChartData(file_formats.CSV,false);
    },
    exportChartDataPptx: async function() {
      const vm = this as any;

      vm.exportChartData(file_formats.POWERPOINT,false);
    },
    exportAllChartDataPptx: async function() {
      const vm = this as any;

      vm.exportChartData(file_formats.POWERPOINT,true);
    },
    downloadDocFromBlob(blob: any, name: string, contentType: string) {
      const newBlob = new Blob([blob], { type: contentType });

      // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, name);
      } else {
        // For other browsers: create a link pointing to the ObjectURL containing the blob.
        const objUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = objUrl;
        link.target = '_blank';
        link.download = name;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL.
        setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
      }
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    setIsSelected: function(index: number) {
      const vm = this as any;
      vm.listaProdottiCensitiForTable[index].isSelected = !vm.listaProdottiCensitiForTable[index].isSelected;
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    formatISODate: function(data: Date) {
      const vm = this as any;

      let dateString = undefined;
      if (data !== undefined && data !== null) {
        dateString = vm.formatDate(new Date(data));
      }

      return dateString;
    },
    setDatePropertiesValue: function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneDaDate);
      vm.filtroRicerca.inizioCommercializzazioneA = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneADate);
      vm.filtroRicerca.fineCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneDaDate);
      vm.filtroRicerca.fineCommercializzazioneA = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneADate);
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    openModalSuccess(msg: string) {
      const vm = this as any;
      vm.msgSuccess = msg;
      vm.$bvModal.show("modal-success");
    },
    closeModalSuccess() {
      const vm = this as any;
      vm.$bvModal.hide("modal-success");
    },
    onClickReturnSuccess() {
      const vm = this as any;
      vm.closeModalSuccess();
    },
    openModalError(msg: string) {
      const vm = this as any;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    openModalConfirmOperation(msg: string, savedFilter: any) {
      const vm = this as any;
      vm.msgConfirmOperation = msg;
      vm.actualSavedFilter = savedFilter;
      vm.$bvModal.show("modal-confirm-operation");
    },
    closeModalConfirmOperation() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-operation");
    },
    onClickReturnConfirmOperation() {
      const vm = this as any;
      if (vm.operationToConfirm == "DELETE") {
        vm.salvaFiltroRicerca(vm.actualSavedFilter);
        vm.actualSavedFilter = null;
      }
      vm.operationToConfirm == "";
      vm.closeModalConfirmOperation();
    },    
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    getTooltipMsg: function(next: boolean) {
      const vm = this as any;

      let i = -1;
      let msg = "";
      if (next) {
        i = vm.slide + 1;
        if (i == Object.keys(vm.mapIndexSlide).length) {
          i = 0;
        }
      } else {
        i = vm.slide - 1;
        if (i < 0) {
          i = Object.keys(vm.mapIndexSlide).length - 1;
        }
      }

      msg = vm.mapIndexSlide[i].name ? vm.mapIndexSlide[i].name : vm.mapIndexSlide[i].fieldName;

      return msg;
    },
    jumpToDatabase(map: any, code: string, type: string, name: string) {
      const vm = this as any;

      let field: any = {};
      field.key = name;
      field.value = {code: code};
      if (type === 'min') {
        field.min = vm.getMinFromStatistics(map);
      }
      if (type === 'max') {
        field.max = vm.getMaxFromStatistics(map);
      }
      if (type === 'avg' || type === 'tot') {
        field.avg = true;
        field.tot = type === 'tot';
      }

      vm.filterDB(field);
    },
    openModalSalvaFiltroRicerca: function() {
      const vm = this as any;

      vm.$bvModal.show("modal-save-search-filter");
    },
    closeModalSalvaFiltroRicerca: function() {
      const vm = this as any;

      vm.$bvModal.hide("modal-save-search-filter");
    },
    salvaFiltroRicerca: async function(searchFilter: any) {
      const vm = this as any;

      let isInsert = false;
      let searchFilterId = undefined;
      let searchFilterState = undefined as any;
      if (searchFilter === undefined) {
        // caso primo salvataggio
        isInsert = true;
      } else if (searchFilter.searchFilterId === undefined) {
        // non dovrebbe mai entrare qui, ma prevediamo lo stesso il caso
        isInsert = true;
      } else {
        // caso accesso mediante funzione "Vedi" o caso delete (o altre future funzioni di update)
        searchFilterId = searchFilter.searchFilterId;
        searchFilterState = searchFilter.state;
      }

      // Se il nome del nuovo filtro ricerca da salvare esiste già bisogna mandare un alert e non consentire il salvataggio
      if (isInsert && vm.isSearchFilterNameAlreadyPresent()) {
        vm.openModalError("Il nome attribuito al filtro di ricerca esiste già, specificare un nome non esistente.");
      } else {
        let filtroRicercaAndCategory = {
          category: vm.codCategoriaProdotto,
          searchFilterId: searchFilterId,
          searchFilterName: vm.nomeFiltroRicercaDaSalvare,
          dbSearchFilter: vm.filtroRicercaAdapted,
          changedFilterFields: vm.changedFilterFields,
          state: searchFilterState
        };

        const serviceCallReturnValue = await requestService
          .saveSearchFilter(
            filtroRicercaAndCategory
          )
          .then(handleResponse)
          /*.then((result: any) => {
            console.log(" result save filtro ricerca " + JSON.stringify(result));
            return result;
          })*/
          .then(() => {
            if (isInsert) {
              vm.closeModalSalvaFiltroRicerca();
            } else if (searchFilterState == "deleted") {
              vm.closeModalConfirmOperation();
            }
          })
          .then(() => {
            if (isInsert) {
              vm.openModalSuccess("Salvataggio filtro ricerca \"" + vm.nomeFiltroRicercaDaSalvare + "\" avvenuto con successo");
              vm.nomeFiltroRicercaDaSalvare = undefined;
            } else if (searchFilterState == "deleted") {
              vm.openModalSuccess("Cancellazione filtro ricerca \"" + searchFilter.searchFilterName + "\" avvenuto con successo");
            }
          })
          .catch(() => {
            vm.openModalError("Errore generico in salvaFiltroRicerca");
          });

        vm.getSearchFiltersList();
      }
    },
    isSearchFilterNameAlreadyPresent() {
      const vm = this as any;

      vm.getSearchFiltersList(); //popola vm.savedSearchFiltersList
      let isSearchFilterNameAlreadyPresent = false;
      vm.savedSearchFiltersList.forEach((item: any) => {
        if (item.searchFilterName == vm.nomeFiltroRicercaDaSalvare) {
          isSearchFilterNameAlreadyPresent = true;
        }
      });

      return isSearchFilterNameAlreadyPresent;
    },
    getSearchFiltersList: async function() {
      const vm = this as any;

      const serviceCallReturnValue = await requestService
        .getSearchFiltersList(
          vm.codCategoriaProdotto
        )
        .then(handleResponse)
        .then((result: any) => {
          vm.savedSearchFiltersList = result;
        })
        .catch(() => {
          vm.openModalError("Errore generico in getSearchFiltersList");
        });
    },
    populateSearchFilterWithSavedSearchFilter: async function(savedFilter: any) {
      const vm = this as any;

      vm.filtroRicerca.compagnia = savedFilter.dbSearchFilter.compagnia;
      vm.filtroRicerca.canale = savedFilter.dbSearchFilter.canale;
      vm.filtroRicerca.mercato = savedFilter.dbSearchFilter.mercato;
      vm.filtroRicerca.distributori = savedFilter.dbSearchFilter.distributori;
      vm.filtroRicerca.tipologiaProdotto = savedFilter.dbSearchFilter.tipologiaProdotto;
      vm.filtroRicerca.tipologiaSottostanti = savedFilter.dbSearchFilter.tipologiaSottostanti;
      if (savedFilter.dbSearchFilter.prodottoInCommercio == "Sì") {
        vm.filtroRicerca.prodottoInCommercio = true;
      } else if (savedFilter.dbSearchFilter.prodottoInCommercio == "No") {
        vm.filtroRicerca.prodottoInCommercio = false;
      }
      vm.filtroRicerca.inizioCommercializzazioneDaDate = vm.dateFromString(savedFilter.dbSearchFilter.inizioCommercializzazioneDa);
      vm.filtroRicerca.inizioCommercializzazioneADate = vm.dateFromString(savedFilter.dbSearchFilter.inizioCommercializzazioneA);
      vm.filtroRicerca.fineCommercializzazioneDaDate = vm.dateFromString(savedFilter.dbSearchFilter.fineCommercializzazioneDa);
      vm.filtroRicerca.fineCommercializzazioneADate = vm.dateFromString(savedFilter.dbSearchFilter.fineCommercializzazioneA);
      vm.filtroRicerca.inizioCommercializzazioneDa = savedFilter.dbSearchFilter.inizioCommercializzazioneDa;
      vm.filtroRicerca.inizioCommercializzazioneA = savedFilter.dbSearchFilter.inizioCommercializzazioneA;
      vm.filtroRicerca.fineCommercializzazioneDa = savedFilter.dbSearchFilter.fineCommercializzazioneDa;
      vm.filtroRicerca.fineCommercializzazioneA = savedFilter.dbSearchFilter.fineCommercializzazioneA;
      vm.filtroRicerca.tipologiaPremio = savedFilter.dbSearchFilter.tipologiaPremio;
      vm.filtroRicerca.impMinPremioUnicoDa = savedFilter.dbSearchFilter.impMinPremioUnicoDa;
      vm.filtroRicerca.impMinPremioUnicoA = savedFilter.dbSearchFilter.impMinPremioUnicoA;
      vm.filtroRicerca.impMinPremioRicorrenteDa = savedFilter.dbSearchFilter.impMinPremioRicorrenteDa;
      vm.filtroRicerca.impMinPremioRicorrenteA = savedFilter.dbSearchFilter.impMinPremioRicorrenteA;

      //ordine applicazione filtri
      vm.changedFilterFields = savedFilter.changedFilterFields;
      if (vm.changedFilterFields == undefined || vm.changedFilterFields == null) {
        vm.changedFilterFields = [];
      }

      //triggera repopulateFiltersOptions per ripopolare le options di tutti i filtri in base ai filtri applicati
      if (savedFilter.changedFilterFields.length > 0) {
        let lastChangedFilterField = savedFilter.changedFilterFields[savedFilter.changedFilterFields.length - 1];
        vm.repopulateFiltersOptions(lastChangedFilterField);
      }

      vm.salvaFiltroRicerca(savedFilter);
    },
    setSearchFilterDeleted: async function(savedFilter: any) {
      const vm = this as any;

      savedFilter.state = "deleted";

      vm.operationToConfirm = "DELETE";
      const msg = "Vuoi cancellare il filtro ricerca \"" + savedFilter.searchFilterName + "\"?"
      vm.openModalConfirmOperation(msg,savedFilter);
    },
    isFilterOn() {
      const vm = this as any;

      if (vm.filtroRicerca.compagnia.length > 0 ||
        vm.filtroRicerca.mercato.length > 0 ||
        vm.filtroRicerca.canale.length > 0 ||
        vm.filtroRicerca.distributori.length > 0 ||
        vm.filtroRicerca.tipologiaProdotto.length > 0 ||
        vm.filtroRicerca.tipologiaSottostanti.length > 0 ||
        vm.filtroRicerca.prodottoInCommercio !== null ||
        vm.filtroRicerca.inizioCommercializzazioneDaDate !== undefined ||
        vm.filtroRicerca.inizioCommercializzazioneADate !== undefined ||
        vm.filtroRicerca.fineCommercializzazioneDaDate !== undefined ||
        vm.filtroRicerca.fineCommercializzazioneADate !== undefined ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.inizioCommercializzazioneDa == undefined ? "" : vm.filtroRicerca.inizioCommercializzazioneDa) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.inizioCommercializzazioneA == undefined ? "" : vm.filtroRicerca.inizioCommercializzazioneA) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.fineCommercializzazioneDa == undefined ? "" : vm.filtroRicerca.fineCommercializzazioneDa) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.fineCommercializzazioneA == undefined ? "" : vm.filtroRicerca.fineCommercializzazioneA) ||
        vm.filtroRicerca.tipologiaPremio.length > 0 ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.impMinPremioUnicoDa == undefined ? "" : vm.filtroRicerca.impMinPremioUnicoDa) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.impMinPremioUnicoA == undefined ? "" : vm.filtroRicerca.impMinPremioUnicoA) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.impMinPremioRicorrenteDa == undefined ? "" : vm.filtroRicerca.impMinPremioRicorrenteDa) ||
        !vm.isEmptyOrSpaces(vm.filtroRicerca.impMinPremioRicorrenteA == undefined ? "" : vm.filtroRicerca.impMinPremioRicorrenteA)) {
        return true;
      }

      return false;
    },
    isFilterOff() {
      const vm = this as any;

      return !vm.isFilterOn();
    },
    hexToRgb(hex: string) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });

      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
  },
  created() {
    this.inizializzaFiltroRicerca();

    this.getPropertyValues()
      .then(result => {
        this.resetFilterOptions();
      });

    this.getStartingIssues();

    this.getSlidesIndexByName();

    this.getSearchFiltersList();

    //pro chart rendimento_gestione_separata
    const actualYear = new Date().getFullYear();
    const lastYear = actualYear-1;
    const firstYear = Math.max(lastYear-this.maxViewAnniRendGs+1, this.baseYearRendGs);
    const years = (lastYear - firstYear) + 1;

    this.rendGsColors = this.rendGsColors.slice(-years);
    this.rendGsColors.forEach((hexColor: any) => {
      const rgbColor = this.hexToRgb(hexColor) as any;
      const rgbStyle = "rgb(" + rgbColor.r + "," + rgbColor.g + "," + rgbColor.b + ")";
      this.rgbRendGsColors.push(rgbStyle);
    });

    let counter = 0;
    this.mapIndexSlide[17].fieldName = "";
    for (let i = firstYear; i <= lastYear; i++) {
      this.anniRendGs.push({year:i,color:this.rgbRendGsColors[counter]});
      counter++;

      this.mapIndexSlide[17].fieldName += "rendimento_gestione_separata_anno_" + i;
      if (i < lastYear) {
        this.mapIndexSlide[17].fieldName += ",";
      }
    }
  },
  mounted() {
    const vm = this as any;

    if (!vm.loggedUser) {
      vm.homeProdotti();
    } else {
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const hasRole = vm.loggedUser.roles.indexOf('vita-investimento') >= 0;

      if (!isAdmin && !hasRole) {
        vm.homeProdotti();
      }
    }

    const tooltip = jquery("<div></div>").addClass("chart-tooltip control-tooltip");
    tooltip.hide();
    jquery("body").append(tooltip);

    function show(next: boolean, event: any) {
      const msg = vm.getTooltipMsg(next); 
      jquery(".control-tooltip")
        .html(msg)
        .css("left", (event.pageX) + "px")
        .css("top", (event.pageY + 20) + "px")
        .show(200);
    }

    function hide() {
      jquery(".control-tooltip").hide();
    }

    jquery(".carousel-control-next-icon").on("mouseover", function(event) {
      show(true, event);
    });
    jquery(".carousel-control-prev-icon").on("mouseover", function(event) {
      show(false, event);
    });
    jquery(".carousel-control-next-icon").on("mouseout", function(event) {
      hide();
    });
    jquery(".carousel-control-prev-icon").on("mouseout", function(event) {
      hide();
    });
  },
  beforeDestroy() {
    jquery(".control-tooltip").remove();
  },
});
